module.exports = function getResource(label, vars = []) {
    const resources = {
        saveText: 'Sauvegarder',
        savedText: 'Sauvegardé'
    };
    return resources[label];
};
